export const PENDING = 0;
export const APPROVED = 1;
export const REJECTED = 2;

export const LeaveTaskStatusText = {
  [PENDING]: "Pending",
  [APPROVED]: "Approved",
  [REJECTED]: "Rejected",
};
